export const ONE_MINUTE = 60 * 1000;
